var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.39541 10.6178L3.18692 9.2469C3.19772 9.22819 3.21688 9.21171 3.24416 9.2044C3.27143 9.19709 3.29627 9.20178 3.31498 9.21259C3.33369 9.22339 3.35018 9.24255 3.35749 9.26983C3.3648 9.2971 3.3601 9.32194 3.3493 9.34065L2.55779 10.7116C1.71118 12.178 2.2163 14.0631 3.68268 14.9097C5.14902 15.7561 7.0334 15.2506 7.87996 13.7843L9.46297 11.0425C10.3095 9.5762 9.80509 7.69153 8.33893 6.84484C8.32027 6.83407 8.30376 6.81476 8.29643 6.7876C8.28912 6.76033 8.29381 6.73549 8.30461 6.71678C8.31542 6.69807 8.33458 6.68158 8.36186 6.67427C8.38904 6.66705 8.41402 6.67169 8.43268 6.68246C9.9896 7.58155 10.5243 9.57919 9.62535 11.1362L8.04234 13.8781C7.14338 15.4351 5.14602 15.9709 3.58893 15.0721C2.03179 14.1731 1.4964 12.175 2.39541 10.6178Z",
    fill: "currentColor",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.60612 3.90792L5.02279 6.65034C3.9857 8.44662 4.60291 10.7501 6.39919 11.7872C6.68029 11.9495 7.04798 11.8509 7.21027 11.5698C7.37256 11.2887 7.27404 10.921 6.99294 10.7588C5.76571 10.0502 5.34265 8.47132 6.05119 7.24409L7.63452 4.50167C8.34307 3.27444 9.92196 2.85138 11.1492 3.55992C12.3764 4.26846 12.7995 5.84736 12.0909 7.07459L11.2993 8.44579C11.137 8.72689 11.2355 9.09458 11.5166 9.25687C11.7977 9.41916 12.1654 9.32064 12.3277 9.03954L13.1194 7.66834C14.1564 5.87206 13.5392 3.5686 11.7429 2.53151C9.94666 1.49443 7.6432 2.11164 6.60612 3.90792Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.18c112d6686e45bfc9322193d2a2f024.svg";
export { ForwardRef as ReactComponent };